import Button from 'src/components/atoms/button/button';
import Modal from 'src/components/atoms/modal/modal';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { updateCommissionGlobal } from 'src/reducers/updates-commission-relations.reducer';
import styles from '../commissions.module.scss';
import Spinner from 'src/components/atoms/spinner/spinner';

type Props = {
  commissionId: number;
};

export const UpdateGlobalCommission = (props: Props) => {
  const dispatch = useAppDispatch();
  const { commissionId } = props;

  const { loadingGlobal } = useAppSelector(state => state.updateCommissionRelations);

  const updateGlobalCommission = () => {
    dispatch(updateCommissionGlobal({ commissionId }));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <div className={styles.globalModalWrapper}>
          <div>
            Sei sicuro di voler modificare lo stato di commessa globale? Così facendo i ruoli e gli utenti associati verranno rimossi.
          </div>
          <Button size="sm" color="white" rounded="rounded-sm" mode="outline" onClick={updateGlobalCommission} disabled={loadingGlobal}>
            {loadingGlobal ? <Spinner /> : 'Modifica'}
          </Button>
        </div>
      </Modal.Body>
    </>
  );
};
